import { render } from "./NoDataFound.vue?vue&type=template&id=e7e4cb72"
import script from "./NoDataFound.vue?vue&type=script&lang=js"
export * from "./NoDataFound.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__